import {
  IconBolt,
  IconBuildingFactory2,
  IconCar,
  IconFlask,
  IconHeartRateMonitor,
  IconPick,
  IconRocket,
  IconShip,
  IconShirt,
  IconSparkles,
  IconTractor,
  IconTopologyStar3,
  IconTruckDelivery,
} from "@tabler/icons-react";
import type { TablerIcon } from "@tabler/icons-react";

export type SectorCardVisual = {
  bg: string;
  border: string;
  iconBg: string;
  iconColor: string;
  titleColor: string;
  hoverBorder: string;
};

export const sectorIconBySlug: Record<string, TablerIcon> = {
  "automotive-mobility-ecosystem": IconCar,
  "industrial-automation-smart-manufacturing-ecosystem": IconBuildingFactory2,
  "textile-apparel-fashion-manufacturing-ecosystem": IconShirt,
  "renewable-energy-electrification-ecosystem": IconBolt,
  "food-beverage-fmcg-ecosystem": IconTruckDelivery,
  "healthcare-pharma-medtech-ecosystem": IconHeartRateMonitor,
  "maritime-ports-offshore-ecosystem": IconShip,
  "chemicals-materials-advanced-manufacturing-ecosystem": IconFlask,
  "infrastructure-construction-smart-cities-ecosystem": IconTopologyStar3,
  "agriculture-agritech-ecosystem": IconTractor,
  "mining-metals-resources-ecosystem": IconPick,
  "digital-transformation-enterprise-technology-ecosystem": IconSparkles,
  "aerospace-space-technology-ecosystem": IconRocket,
};

export const sectorVisualBySlug: Record<string, SectorCardVisual> = {
  "automotive-mobility-ecosystem": {
    bg: "#EFF6FF",
    border: "#BFDBFE",
    iconBg: "#DBEAFE",
    iconColor: "#1D4ED8",
    titleColor: "#1E3A8A",
    hoverBorder: "#93C5FD",
  },
  "industrial-automation-smart-manufacturing-ecosystem": {
    bg: "#F5F3FF",
    border: "#DDD6FE",
    iconBg: "#EDE9FE",
    iconColor: "#6D28D9",
    titleColor: "#4C1D95",
    hoverBorder: "#C4B5FD",
  },
  "textile-apparel-fashion-manufacturing-ecosystem": {
    bg: "#FDF2F8",
    border: "#FBCFE8",
    iconBg: "#FCE7F3",
    iconColor: "#DB2777",
    titleColor: "#9D174D",
    hoverBorder: "#F9A8D4",
  },
  "renewable-energy-electrification-ecosystem": {
    bg: "#FFFBEB",
    border: "#FDE68A",
    iconBg: "#FEF3C7",
    iconColor: "#D97706",
    titleColor: "#92400E",
    hoverBorder: "#FCD34D",
  },
  "food-beverage-fmcg-ecosystem": {
    bg: "#FFF7ED",
    border: "#FED7AA",
    iconBg: "#FFEDD5",
    iconColor: "#EA580C",
    titleColor: "#9A3412",
    hoverBorder: "#FDBA74",
  },
  "healthcare-pharma-medtech-ecosystem": {
    bg: "#ECFDF5",
    border: "#A7F3D0",
    iconBg: "#D1FAE5",
    iconColor: "#059669",
    titleColor: "#065F46",
    hoverBorder: "#6EE7B7",
  },
  "maritime-ports-offshore-ecosystem": {
    bg: "#ECFEFF",
    border: "#A5F3FC",
    iconBg: "#CFFAFE",
    iconColor: "#0891B2",
    titleColor: "#155E75",
    hoverBorder: "#67E8F9",
  },
  "chemicals-materials-advanced-manufacturing-ecosystem": {
    bg: "#F0FDF4",
    border: "#BBF7D0",
    iconBg: "#DCFCE7",
    iconColor: "#16A34A",
    titleColor: "#166534",
    hoverBorder: "#86EFAC",
  },
  "infrastructure-construction-smart-cities-ecosystem": {
    bg: "#F8FAFC",
    border: "#CBD5E1",
    iconBg: "#E2E8F0",
    iconColor: "#475569",
    titleColor: "#1E293B",
    hoverBorder: "#94A3B8",
  },
  "agriculture-agritech-ecosystem": {
    bg: "#F7FEE7",
    border: "#D9F99D",
    iconBg: "#ECFCCB",
    iconColor: "#65A30D",
    titleColor: "#3F6212",
    hoverBorder: "#BEF264",
  },
  "mining-metals-resources-ecosystem": {
    bg: "#FEF2F2",
    border: "#FECACA",
    iconBg: "#FEE2E2",
    iconColor: "#DC2626",
    titleColor: "#991B1B",
    hoverBorder: "#FCA5A5",
  },
  "digital-transformation-enterprise-technology-ecosystem": {
    bg: "#EEF2FF",
    border: "#C7D2FE",
    iconBg: "#E0E7FF",
    iconColor: "#4F46E5",
    titleColor: "#312E81",
    hoverBorder: "#A5B4FC",
  },
  "aerospace-space-technology-ecosystem": {
    bg: "#F5F3FF",
    border: "#DDD6FE",
    iconBg: "#EDE9FE",
    iconColor: "#5B21B6",
    titleColor: "#4C1D95",
    hoverBorder: "#C4B5FD",
  },
};

export const defaultSectorVisual: SectorCardVisual = {
  bg: "#F8FAFC",
  border: "#E2E8F0",
  iconBg: "#E2E8F0",
  iconColor: "#04305c",
  titleColor: "#04305c",
  hoverBorder: "#CBD5E1",
};

export function getSectorIcon(slug: string) {
  return sectorIconBySlug[slug] ?? IconSparkles;
}

export function getSectorVisual(slug: string) {
  return sectorVisualBySlug[slug] ?? defaultSectorVisual;
}
